// extracted by mini-css-extract-plugin
module.exports = {"Splash":"Splash_Splash__1H97R","text-container":"Splash_text-container__16h7O","glow":"Splash_glow__2HdWk","glitch":"Splash_glitch__2Okih"};